import React, { Suspense } from "react";
import { UserData } from "../AppRoutes";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import MainPage from "../../pages/main-pages/MainPage";

interface ThirtyFthirtyRoutesProps {
  setIsAuthenticated: React.Dispatch<React.SetStateAction<UserData | null>>;
}

const Events = React.lazy(
  () => import("../../pages/main-pages/30-for-30/events/list/EventList"),
);

const Sponsor = React.lazy(
  () => import("../../pages/main-pages/30-for-30/sponsor/list/SponsorList"),
);

const Team = React.lazy(
  () => import("../../pages/main-pages/30-for-30/team/list/TeamList"),
);

const ThirtyForThirtyRoutes: React.FC<ThirtyFthirtyRoutesProps> = ({
  setIsAuthenticated,
}) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route
          path="/"
          element={<MainPage setIsAuthenticated={setIsAuthenticated} />}
        >
          {/* Default redirect */}
          <Route index element={<Navigate to="participants" replace />} />

          {/* All sidebar routes */}
          <Route
            path="participants"
            element={<div>Participants for 30 for 30</div>}
          />
          <Route path="event" element={<Events />} />
          <Route path="challenges" element={<div>Challenges Page</div>} />
          <Route path="winners" element={<div>Winners Page</div>} />
          <Route path="sponsor" element={<Sponsor />} />
          <Route path="team" element={<Team />} />
          <Route path="school" element={<div>School Page</div>} />
          <Route
            path="fitness-activity"
            element={<div>Fitness Activity Page</div>}
          />
          <Route path="badges" element={<div>Badges Page</div>} />
          <Route
            path="achievement-badges"
            element={<div>Achievement Badges Page</div>}
          />
          <Route path="activity-log" element={<div>Activity Log Page</div>} />
          <Route path="reports" element={<div>Reports Page</div>} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default ThirtyForThirtyRoutes;
